export abstract class Application {
  public static init() {
    /**
     * Added to make some sloppy Node.js packages work in browser (e.g. 'deep-equal').
     * Uncomment other lines if more exceptions occur.
     */
    (window as any).global = window;
    // global.Buffer = global.Buffer || require('buffer').Buffer;
    // global.process = require('process');
  }
}
